import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { CalendarClock, Send, X } from "lucide-react";

const DialogoFechaCaja = ({ open, onOpenChange, onConfirm, onCancel, fechaCalculo }) => {
  const fechaFormateada = fechaCalculo
    ? new Date(fechaCalculo + "T12:00:00").toLocaleDateString("es-VE", { day: "2-digit", month: "long", year: "numeric" })
    : "desconocida";

  const hoy = new Date().toLocaleDateString("es-VE", { day: "2-digit", month: "long", year: "numeric" });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[440px]" data-testid="dialogo-fecha-caja">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <CalendarClock className="w-5 h-5" />
            Fecha fuera del mes en curso
          </DialogTitle>
          <DialogDescription className="pt-3 text-slate-600 leading-relaxed">
            El cálculo que está enviando a caja tiene fecha <strong className="text-slate-800">{fechaFormateada}</strong> y no corresponde al mes en curso.
            <br /><br />
            ¿Desea cambiar la fecha al día de hoy (<strong className="text-slate-800">{hoy}</strong>) para proceder?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onCancel} data-testid="dialogo-fecha-caja-no">
            <X className="w-4 h-4 mr-1" /> No, cancelar
          </Button>
          <Button onClick={onConfirm} className="bg-amber-600 hover:bg-amber-700" data-testid="dialogo-fecha-caja-si">
            <Send className="w-4 h-4 mr-1" /> Sí, actualizar fecha
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { DialogoFechaCaja };
